import ImageOne from '../images/ImageNine.png'
import ImageTwo from '../images/ImageSix.png'
import ImageThree from '../images/Sobre.jpg'
import ImageFour from '../images/svg-5.svg'

export const InfoData = {
    heading: 'Planejamento',
    paragraphOne: 'Ao escolher a MÓVEL SMART Planejados para desenvolver o seu projeto iremos te oferecer tudo aquilo que você merece e muito mais!',
    paragraphTwo: 'Além de um projeto planejado incrível, oferecemos toda a consultoria necessária para que seu projeto seja um sucesso!',
    buttonLabel: 'Ver mais',
    image: ImageOne,
    reverse: false,
    exist: true,
    delay: 100,
};

export const InfoData2 = {
    heading: 'Qualidade',
    paragraphOne: 'Trata-se de uma empresa que busca a satisfação de seus clientes, leva a sério esta filosofia se envolvendo com todos os detalhes dos projetos.',
    paragraphTwo: '',
    buttonLabel: 'Ver mais',
    image: ImageTwo,
    reverse: true,
    exist: true,
    delay: 300,
};

export const InfoData3 = {
    heading: 'Nossos objetivos',
    paragraphOne: 'A empresa nasceu  com o propósito de realizar o sonhos de seus clientes idealizando projetos de móveis sob medida com qualidade, para deixar uma das maiores conquistas dos nossos clientes com o seu  estilo.',
    paragraphTwo: 'A MÓVEL SMART  fornece aos clientes, móveis residenciais e comerciais, utilizamos matéria prima da mais alta qualidade, agregamos as mais modernas tendências de acabamento e design, para atender nossos clientes com excelência! Nosso processo de fabricação está pautado de acordo com a indústria 4.0, o que oferece ao cliente: agilidade na fabricação e entrega do seu mobiliário sem perder as características artesanais e qualidade que todo cliente procura e merece, tendo compromisso com técnicas de máximo aproveitamento de matérias-primas evitando sobras e desperdício de materiais, contribuindo com a preservação do meio ambiente.',
    buttonLabel: '',
    image: ImageThree,
    exist: false,
    delay: 300,
};

export const InfoData4 = {
    heading: 'Envio confirmado!',
    paragraphOne: 'Acabamos de receber a resposta do seu formulário, em breve entraremos em contato!',
    paragraphTwo: 'Por favor, aguarde.',
    buttonLabel: 'Voltar',
    image: ImageFour,
    exist: true,
    delay: 300,
};

